module.exports = __webpack_public_path__ + "img/cup.339fc91b.svg";